export default {
  domain: '',
}